import { memo } from 'react';

import type { ApiNotification } from '@izimi/api';

import { NotificationSharedItemAction } from './NotificationSharedItemAction';

interface Props {
  notification: ApiNotification;
}

export const ContactRequestReceivedActions = memo(({ notification }: Props) => (
  <NotificationSharedItemAction notification={notification} targetPath='/sharing/to-you' />
));
